import React, { useState, useContext, useEffect } from "react";
import AlertComponent from "../AlertComponent";
import Image from "../Image/image";
import "./UploadImageHootSuite.scss";
import FieldHootsuiteUpload from "../Fields/FieldHootsuiteUpload";
import AiImageSelector from "../AiImageSelector/aiimageselector";
import { Button } from "react-bootstrap";

import AiSelectIcon from "../../Assets/Images/ai-select.svg";
import UploadFileIcon from "../../Assets/Images/upload-media.svg";

const UploadImageHootSuite = (props) => {
  const [userUploadedImage, setUserUploadedImage] = useState(null);
  const [userUploadedBlob, setUserUploadedBlob] = useState(null);
  const [aiSelectedImage, setAiSelectedImage] = useState(props.sentImageUrl ?? null);
  const [userChooseImage, setUserChooseImage] = useState(props.sentMessage ?? false);
  const [showImageSelector, setShowImageSelector] = useState(false);

  const [userSelectedImage, setUserSelectedImage] = useState(null);

  const handleShowSelector = (show) => {
    setShowImageSelector(show);
  };

  const previewIcon = `https://cdn-icons-png.flaticon.com/512/5799/5799674.png`;
  const previewBoat = `https://as2.ftcdn.net/v2/jpg/01/42/50/23/1000_F_142502309_3cMLuIp1Gxmmk5mJkyabQ2JZLE5Pka6d.jpg`;

  useEffect(() => {
    const userImage = userUploadedImage !== null && userUploadedImage !== previewIcon;
    const aiImage = aiSelectedImage !== null && aiSelectedImage !== previewBoat;

    if (userImage) {
      setUserSelectedImage(userUploadedBlob);
    } else if (aiImage) {
      setUserSelectedImage(aiSelectedImage);
      props.onSelect(true, aiSelectedImage);
    } else {
      props.onSelect(false, null);
    }

    setUserChooseImage(userImage || aiImage);
  }, [userUploadedImage, aiSelectedImage]);

  const handleImageSelector = () => {
    handleShowSelector(true);
  };

  const handleUserImageUpload = (file, blob) => {
    props.onSelect(false, file);
    setUserUploadedImage(file);
    setUserUploadedBlob(blob);
  };

  const handleRemoveImage = () => {
    setUserSelectedImage(null);
    setUserUploadedImage(null);
    setUserUploadedBlob(null);
    setAiSelectedImage(null);
  };
  const upscaledImages = props.messages.filter((x) => x.isImage && !x.canUpscale);

  return (
    <div className="hootsuite-image-uploader">
      <div className="message-upload">
        <h5>Suggested media</h5>
        <small>Make sure you have the rights to use the suggested media.</small>
      </div>
      <div className="upload-components">
        <AiImageSelector images={upscaledImages} showImageSelector={showImageSelector} setShowImageSelector={handleShowSelector} onSelect={setAiSelectedImage} />
        {!userChooseImage && (
          <>
            <div className="profile-avatar-container" style={{ pointerEvents: props.sentMessage ? 'none' : 'auto' }}>
              <FieldHootsuiteUpload
                classNames="profile-avatar-column"
                radius={`0`}
                previewUrl={UploadFileIcon}
                onChange={handleUserImageUpload}
                className="upload-picture"
                imgWrapClass="img-wrap-hootsuite"
                readOnly={props.sentMessage}
              />
            </div>

            {upscaledImages.length > 0 && (
              <div
                className={"form-group profile-avatar-column upload-picture custom-file-upload"}
                style={{ textAlign: "center", marginLeft: "10px" }}
                onClick={handleImageSelector}>
                <div className={`img-wrap img-upload img-wrap-hootsuite full-image`}>
                  <Image className="main-chat-content" src={AiSelectIcon} radius={20} />
                </div>
              </div>
            )}
          </>
        )}

        {userChooseImage && (
          <div className={"form-group profile-avatar-column upload-picture custom-file-upload"} style={{ textAlign: "center" }}>
            <div className={`img-wrap img-upload img-wrap-hootsuite full-image`}>
              <Image className="main-chat-content" src={userSelectedImage} radius={20} />
              {!props.sentMessage && <div className="blur-bg">
                <div className="image-actions">
                  <Button size="sm" className="upscale-btn" onClick={handleRemoveImage}>
                    Remove Image
                  </Button>
                </div>
              </div>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default UploadImageHootSuite;
